import ContentLoader from 'react-content-loader';

import { SearchInput } from '../../../generic';

import styles from './BinaryAnalysisContainer.module.less';

const ROW_HEIGHT = 36;
const INDENT = 16;
const ICON_SIZE = 16;
const ARROW_SIZE = 12;

const BinaryTreeLoading = () => (
  <>
    <SearchInput value="" onChange={() => {}} size="small" label="binary-tree-search-loading" isDisabled />

    {/* Tree Loading */}
    <div className={styles.treeContainer}>
      <ContentLoader
        speed={2}
        width={400}
        height={ROW_HEIGHT * 8}
        viewBox={`0 0 400 ${ROW_HEIGHT * 8}`}
      >
        {/* Root folder (/) with arrow and folder icon */}
        <rect x="4" y={6} rx="2" ry="2" width={ARROW_SIZE} height={ARROW_SIZE} />
        <rect x="20" y={6} rx="2" ry="2" width={ICON_SIZE} height={ICON_SIZE} />
        <rect x="42" y="8" rx="4" ry="4" width="20" height="20" />

        {/* First level folder with arrow and icon */}
        <rect x={INDENT + 4} y={ROW_HEIGHT + 6} rx="2" ry="2" width={ARROW_SIZE} height={ARROW_SIZE} />
        <rect x={INDENT + 20} y={ROW_HEIGHT + 6} rx="2" ry="2" width={ICON_SIZE} height={ICON_SIZE} />
        <rect x={INDENT + 42} y={ROW_HEIGHT + 8} rx="4" ry="4" width="200" height="20" />

        {/* Second level folder */}
        <rect x={INDENT * 2 + 4} y={ROW_HEIGHT * 2 + 6} rx="2" ry="2" width={ARROW_SIZE} height={ARROW_SIZE} />
        <rect x={INDENT * 2 + 20} y={ROW_HEIGHT * 2 + 6} rx="2" ry="2" width={ICON_SIZE} height={ICON_SIZE} />
        <rect x={INDENT * 2 + 42} y={ROW_HEIGHT * 2 + 8} rx="4" ry="4" width="120" height="20" />

        {/* Third level files */}
        <rect x={INDENT * 3 + 20} y={ROW_HEIGHT * 3 + 6} rx="2" ry="2" width={ICON_SIZE} height={ICON_SIZE} />
        <rect x={INDENT * 3 + 42} y={ROW_HEIGHT * 3 + 8} rx="4" ry="4" width="180" height="20" />

        <rect x={INDENT * 3 + 20} y={ROW_HEIGHT * 4 + 6} rx="2" ry="2" width={ICON_SIZE} height={ICON_SIZE} />
        <rect x={INDENT * 3 + 42} y={ROW_HEIGHT * 4 + 8} rx="4" ry="4" width="160" height="20" />

        {/* Another second level folder */}
        <rect x={INDENT * 2 + 4} y={ROW_HEIGHT * 5 + 6} rx="2" ry="2" width={ARROW_SIZE} height={ARROW_SIZE} />
        <rect x={INDENT * 2 + 20} y={ROW_HEIGHT * 5 + 6} rx="2" ry="2" width={ICON_SIZE} height={ICON_SIZE} />
        <rect x={INDENT * 2 + 42} y={ROW_HEIGHT * 5 + 8} rx="4" ry="4" width="140" height="20" />

        {/* Another first level folder */}
        <rect x={INDENT + 4} y={ROW_HEIGHT * 6 + 6} rx="2" ry="2" width={ARROW_SIZE} height={ARROW_SIZE} />
        <rect x={INDENT + 20} y={ROW_HEIGHT * 6 + 6} rx="2" ry="2" width={ICON_SIZE} height={ICON_SIZE} />
        <rect x={INDENT + 42} y={ROW_HEIGHT * 6 + 8} rx="4" ry="4" width="100" height="20" />

        {/* Second level collapsed folder */}
        <rect x={INDENT * 2 + 4} y={ROW_HEIGHT * 7 + 6} rx="2" ry="2" width={ARROW_SIZE} height={ARROW_SIZE} />
        <rect x={INDENT * 2 + 20} y={ROW_HEIGHT * 7 + 6} rx="2" ry="2" width={ICON_SIZE} height={ICON_SIZE} />
        <rect x={INDENT * 2 + 42} y={ROW_HEIGHT * 7 + 8} rx="4" ry="4" width="170" height="20" />
      </ContentLoader>
    </div>
  </>
);

export default BinaryTreeLoading;
